import { render, staticRenderFns } from "./CrowdFundingPage.vue?vue&type=template&id=a318aa80&scoped=true&"
import script from "./CrowdFundingPage.vue?vue&type=script&lang=js&"
export * from "./CrowdFundingPage.vue?vue&type=script&lang=js&"
import style0 from "./CrowdFundingPage.vue?vue&type=style&index=0&id=a318aa80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a318aa80",
  null
  
)

export default component.exports